'use client';

import { useTranslations } from 'next-intl';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/app/components/ui/dialog';

export interface ReferenceAudioPreviewInfo {
  id?: string;
  name?: string;
  src: string;
  duration?: number;
}

interface ReferenceAudioPreviewDialogProps {
  audio: ReferenceAudioPreviewInfo | null;
  onOpenChange: (open: boolean) => void;
}

export function ReferenceAudioPreviewDialog({ audio, onOpenChange }: ReferenceAudioPreviewDialogProps) {
  const t = useTranslations();

  return (
    <Dialog open={!!audio} onOpenChange={onOpenChange}>
      <DialogContent className="w-[420px] gap-5 p-6 sm:w-[calc(100vw-32px)]">
        <DialogHeader>
          <DialogTitle className="truncate pr-8 text-base">
            {audio?.name || t('create.char2VideoForm.audio')}
          </DialogTitle>
        </DialogHeader>
        <audio key={audio?.src} className="w-full" controls src={audio?.src}>
          <track kind="captions" />
        </audio>
      </DialogContent>
    </Dialog>
  );
}
